import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import Ajax from "@/utils/DuduAjax";
import { showConfirm, showSuccess, showWarning } from "@/utils/UI";
import { API_BIS_PATENT_BATCHINDEXING } from "@/configs/Apis";
import { useStore } from "@/stores";


export default /*#__PURE__*/_defineComponent({
  __name: 'BatchIndex',
  props: {
  patentIdList: {
    type: Array,
    default: () => [],
    required: true,
  },
},
  emits: ["data-changed"],
  setup(__props, { expose, emit }) {

const props = __props;




const store = useStore();
const projectId = computed(() => {
  const pInfo: any = (store.state as any).project.info || {};
  return pInfo.id || 0;
});

const changed = ref(false);
const visible = ref(false);
const loading = ref(false);
const data = ref<any>({});

const customFields = computed(() => store.getters["project/customfields"]);

const open = () => {
  visible.value = true;
};

const closeDialog = () => {
  visible.value = false;
  if (changed.value) {
    emit("data-changed");
    changed.value = false;
  }
};

const doCleanData = () => {
  if (!props.patentIdList || !props.patentIdList.length) {
    showWarning("请选择专利数据");
    return;
  }
  showConfirm("是否批量修改标引字段").then(async () => {
    try {
      loading.value = true;
      const indexingInfo: Array<any> = [];
      Object.keys(data.value).forEach((key) => indexingInfo.push([key.replace("_", ""), data.value[key]]));
      await Ajax.post(
        { url: API_BIS_PATENT_BATCHINDEXING, path: { projectId: projectId.value } },
        { patentIdList: props.patentIdList, indexingInfo }
      );
      showSuccess("标引成功");
      changed.value = true;
      closeDialog();
    } finally {
      loading.value = false;
    }
  });
};

expose({ open });

return { __sfc: true,props, emit, store, projectId, changed, visible, loading, data, customFields, open, closeDialog, doCleanData }
}

})